const styles = (theme) => ({
  noAccountsLabel: {
    fontSize: 18,
    color: 'inherit',
  },
  questionContainer: {
    textAlign: 'center'
  },
  stepRequired: {
    color: theme.palette.primary.main
  }
});

export default styles;